// Valeurs partagées par les sections du moteur "agence_v1" — reprises des
// « Design Tokens » du handoff ClickExpert. Tout ce qui est COULEUR passe
// par la palette de la boutique (Studio de thème > Palette), jamais par un
// hex codé en dur : le handoff est le contenu par défaut de ce moteur, pas
// une maquette figée que l'admin ne pourrait plus recolorer.
//
// Correspondance palette ↔ tokens du handoff :
//   cream    → --bg ivoire #F7F4ED          ink      → --ink #16150F
//   sand     → fond de carte                graphite → texte secondaire
//   stone    → bordures                     ash      → texte tertiaire
//   gold     → --green-ink (numéros de service, coches sur fond clair, liens)
//   copper   → --green-link-hover           blush    → --lime (CTA, coches sur fond sombre)

// Police d'accent du handoff (Instrument Serif) — prix, chiffres clés et le
// mot en italique du titre principal. Chargée par la paire de polices
// "grotesk_ibmplex" (voir FONT_PAIRS côté serveur) ; le repli `serif` garde
// la page lisible si Google Fonts est bloqué.
export const SERIF = '"Instrument Serif", Georgia, serif';

// --ink-panel #20201A du handoff : le noir olive du panneau « Suivi de
// projet » et de la carte « Sur-mesure », très légèrement plus clair que le
// fond de la section Tarifs. Dérivé de `ink` plutôt que codé en dur, pour
// qu'il suive la palette de la boutique.
export const PANEL_BG = {
  backgroundColor: "rgb(var(--c-ink, 22 21 15))",
  backgroundImage: "linear-gradient(rgba(255,255,255,0.045), rgba(255,255,255,0.045))",
};

// Conteneur du handoff : max-width 1240px, padding horizontal 28px (18px
// sous 780px — le point de rupture `md` de Tailwind, 768px, en est le plus
// proche).
export const CONTAINER = "max-w-[1240px] mx-auto px-[18px] md:px-7";

// Couleurs de ZONE du Studio (Palette > En-tête / Pied de page, voir
// ZONE_PALETTE_KEYS côté serveur) sur le chrome du moteur.
//
// Pied de page : le handoff a un pied CLAIR (fond ivoire, texte encre), à
// l'inverse du repli ink/cream des classes footer-bg/footer-text de
// tailwind.config.js — ces classes changeraient le rendu par défaut. D'où
// deux variables locales, posées sur le <footer>, qui suivent la zone quand
// elle est choisie et retombent sur cream/ink sinon.
export const FOOTER_VARS = {
  "--ag-footer-bg": "var(--c-footer_bg, var(--c-cream, 247 244 237))",
  "--ag-footer-text": "var(--c-footer_text, var(--c-ink, 22 21 15))",
};
export const FOOTER_BG = "bg-[rgb(var(--ag-footer-bg))]";
export const FOOTER_TEXT = "text-[rgb(var(--ag-footer-text)/0.45)]";
export const FOOTER_TEXT_HOVER = "hover:text-[rgb(var(--ag-footer-text))]";
export const FOOTER_RULE = "border-[rgb(var(--ag-footer-text)/0.09)]";
// En-tête : cream/ink sont bien les replis de header-bg/header-text, les
// classes Tailwind servent directement. Seul le monogramme (SVG recoloré
// en inline) a besoin de la valeur brute.
export const HEADER_MARK = "rgb(var(--c-header_text, var(--c-ink, 22 21 15)))";

// Une ligne = un élément, pour les champs "liste" du moteur (features,
// excluded, chips, plan_options...). Même convention que "checklist" du
// moteur "default".
export const lines = (value) =>
  (value || "").split("\n").map((s) => s.trim()).filter(Boolean);
